import Button from 'apollo-react/components/Button';
import qs from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import BulkImportActionsMenu from '../../components/BulkImport/BulkImportActionsMenu';
import PowerBIReportsActionsMenu from '../../components/PowerBI/PowerBIReportsActionsMenu';
import withTranslation from '../../components/withTranslation';
import { ENTITY_NAMES } from '../../constants/MasterSetupConstants';
import { POWERBI_ENABLED_APP_SETTING, POWERBI_ENTITY_NAME } from '../../constants/PowerBIConstants';
import { WORKFLOW_STEP } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getAppSettingsByKey } from '../../selectors/AppConfigsSelectors';
import {
  checkManageRightByEntityName,
  getIsAddRecordButtonEnabled,
  getIsBulkImportEnabled,
} from '../../selectors/MasterSetupPageSelectors';
import { getUITA } from '../../utils/commonUtils';

const MasterSetupTableActions = ({ entityName, selectedReports, setSelectedReports }) => {
  const translateString = useTranslation();

  const { searchName } = useSelector((state) => state.masterSetupPage);
  const showAddRecordButton = useSelector(getIsAddRecordButtonEnabled);
  const showBulkImportActions = useSelector(getIsBulkImportEnabled);
  const isPowerBIEnabled = useSelector(getAppSettingsByKey(POWERBI_ENABLED_APP_SETTING));
  const hasManageRight = useSelector((state) =>
    checkManageRightByEntityName(state, { entityName })
  );

  const isManagePowerBIEntity = entityName === POWERBI_ENTITY_NAME;

  const isSubmissionCode = entityName === ENTITY_NAMES.SUBMISSION_CODE;

  return (
    <>
      {isSubmissionCode && <BulkImportActionsMenu entityName={entityName} />}
      {showAddRecordButton && hasManageRight && (
        <>
          {!isManagePowerBIEntity && showBulkImportActions && (
            <BulkImportActionsMenu entityName={entityName} />
          )}
          {isManagePowerBIEntity && isPowerBIEnabled && (
            <PowerBIReportsActionsMenu
              selectedReports={selectedReports}
              setSelectedReports={setSelectedReports}
            />
          )}
          <Link
            to={{
              pathname: WORKFLOW_STEP,
              search: qs.stringify({
                entityType: entityName,
                formKey: `${entityName}_MASTERSETUP`,
                entityViewName: `V_${entityName}`,
                searchName,
              }),
            }}
            ui-ta={getUITA('add-new-record')}
          >
            <Button color="secondary" variant="secondary">
              {translateString('Add Record')}
            </Button>
          </Link>
        </>
      )}
    </>
  );
};

export default withTranslation(MasterSetupTableActions);
